import { render, staticRenderFns } from "./PaymentsModal.vue?vue&type=template&id=6d58e6f8&scoped=true&"
import script from "./PaymentsModal.vue?vue&type=script&lang=js&"
export * from "./PaymentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d58e6f8",
  null
  
)

export default component.exports